import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, FormControl, InputLabel, Select, FormHelperText, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import axiosInstance from '../../axios.config';

export const UpdateQuizQuestionModal = ({ showEdit, setShowEdit, lngsltd, editQuestion, handleEditInputChangeQN, questionNumberError,
    handleEditInputChange, questionTextError, handleRemoveImage, setEditQuestion,
    option1Error, option2Error, option3Error, option4Error, correctOptionError, handleEditCheckboxChange, handleEdit }) => {
    return (
        <Dialog open={showEdit} onClose={() => setShowEdit(false)} fullWidth>
            <DialogTitle style={{ backgroundColor: '#efedf0' }}>
                {lngsltd["Edit Question"]}
            </DialogTitle>
            <DialogContent>

                <FormControl fullWidth margin="normal" sx={{ mt: 3 }}>
                    <InputLabel>{lngsltd["Select Language"]}</InputLabel>
                    <Select
                        label={lngsltd["Select Language"]}
                        id="languageCode"
                        name="languageCode"
                        value={editQuestion.languageCode}
                        onChange={(e) => setEditQuestion({
                            ...editQuestion,
                            languageCode: e.target.value[0]
                        })}
                    >
                        <MenuItem value="en-US">{lngsltd["English"]}</MenuItem>
                        <MenuItem value="nb-NO">{lngsltd["Norwegian"]}</MenuItem>

                    </Select>
                </FormControl>

                <TextField
                    label={lngsltd["Question Number"]}
                    fullWidth
                    margin="normal"
                    name="questionNo"
                    value={editQuestion.questionNo}
                    onChange={handleEditInputChangeQN}
                    error={Boolean(questionNumberError)}
                    helperText={questionNumberError}
                />
                <TextField
                    label={`${lngsltd["Question Text"]} *`}
                    fullWidth
                    margin="normal"
                    name="questionText"
                    value={editQuestion.questionText}
                    onChange={handleEditInputChange}
                    error={Boolean(questionTextError)}
                    helperText={questionTextError}
                />
                {(editQuestion.imageFile || (editQuestion.imageName && editQuestion.imageName !== "No Image")) && (
                    <Grid container spacing={2} alignItems="center" marginY={2}>
                        <Grid item>
                            <Typography>{lngsltd["Selected Image Preview"]}:</Typography>
                        </Grid>
                        <Grid item>
                            {editQuestion.imageFile ? (
                                <img src={URL.createObjectURL(editQuestion.imageFile)} alt="Selected Image Preview" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                            ) : (
                                <img 
                                    src={`${axiosInstance.defaults.baseURL}/Question/Image/${editQuestion.quizID}/${editQuestion.questionNo}/${editQuestion.imageName}`}
                                    alt="Question Image" 
                                    style={{ maxWidth: '100px', maxHeight: '100px' }}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                />
                            )}
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="secondary" onClick={handleRemoveImage}>
                                {lngsltd["Remove Image"]}
                            </Button>
                        </Grid>
                    </Grid>
                )}

                <Typography variant="subtitle1" gutterBottom>{lngsltd["Image File"]} :</Typography>
                <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    margin="normal"
                >
                    {lngsltd["Image File"]}
                    <input
                        type="file"
                        hidden
                        name="imageFile"
                        onChange={(e) => setEditQuestion({ ...editQuestion, imageFile: e.target.files[0] })}
                    />
                </Button>

                <FormControl fullWidth margin="normal" sx={{ mt: 3 }}>
                    <InputLabel>{"Question Type"}</InputLabel>
                    <Select
                        label={"Question Type"}
                        id="questionType"
                        name="questionType"
                        value={editQuestion.questionType}
                        onChange={(e) => setEditQuestion({
                            ...editQuestion,
                            questionType: e.target.value,
                            correctOptions: []
                        })}
                    >
                        <MenuItem value="Single Choice">Single Choice</MenuItem>
                        <MenuItem value="Multiple Choice">Multiple Choice</MenuItem>
                        <MenuItem value="True/False">True/False</MenuItem>
                    </Select>
                </FormControl>

                <TextField
                    label={`${lngsltd["Option 1"]} *`}
                    fullWidth
                    margin="normal"
                    name="option1"
                    value={editQuestion.option1}
                    onChange={handleEditInputChange}
                    error={Boolean(option1Error)}
                    helperText={option1Error}
                />
                <TextField
                    label={`${lngsltd["Option 2"]} *`}
                    fullWidth
                    margin="normal"
                    name="option2"
                    value={editQuestion.option2}
                    onChange={handleEditInputChange}
                    error={Boolean(option2Error)}
                    helperText={option2Error}
                />
                {editQuestion.questionType !== "True/False" && (
                    <>
                        <TextField
                            label={`${lngsltd["Option 3"]} *`}
                            fullWidth
                            margin="normal"
                            name="option3"
                            value={editQuestion.option3}
                            onChange={handleEditInputChange}
                            error={Boolean(option3Error)}
                            helperText={option3Error}
                        />
                        <TextField
                            label={`${lngsltd["Option 4"]} *`}
                            fullWidth
                            margin="normal"
                            name="option4"
                            value={editQuestion.option4}
                            onChange={handleEditInputChange}
                            error={Boolean(option4Error)}
                            helperText={option4Error}
                        />
                    </>
                )}
                {(editQuestion.questionType === "Single Choice" || editQuestion.questionType === "True/False") && (
                    <FormControl fullWidth margin="normal">
                        <InputLabel>{lngsltd["Correct Option"]}</InputLabel>
                        <Select
                            label={lngsltd["Correct Option"]}
                            name="correctOption"
                            value={editQuestion.correctOptions && editQuestion.correctOptions.length > 0 ? editQuestion.correctOptions[0] : ''}
                            onChange={handleEditInputChange}
                            error={Boolean(correctOptionError)}
                        >
                            <MenuItem value="" disabled>{lngsltd["Select Correct Option"]}</MenuItem>
                            {editQuestion.option1 && <MenuItem value={editQuestion.option1}>{editQuestion.option1}</MenuItem>}
                            {editQuestion.option2 && <MenuItem value={editQuestion.option2}>{editQuestion.option2}</MenuItem>}
                            {editQuestion.questionType === "Single Choice" && editQuestion.option3 && (
                                <MenuItem value={editQuestion.option3}>{editQuestion.option3}</MenuItem>
                            )}
                            {editQuestion.questionType === "Single Choice" && editQuestion.option4 && (
                                <MenuItem value={editQuestion.option4}>{editQuestion.option4}</MenuItem>
                            )}
                        </Select>
                        {correctOptionError && <FormHelperText error>{correctOptionError}</FormHelperText>}
                    </FormControl>
                )}
                {editQuestion.questionType === "Multiple Choice" && (
                    <div>
                        <Typography>{"Correct Options"}</Typography>
                        {[editQuestion.option1, editQuestion.option2, editQuestion.option3, editQuestion.option4].map((option, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox
                                        checked={editQuestion.correctOptions.includes(option)}
                                        onChange={(e) => handleEditCheckboxChange(option, e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label={option}
                            />
                        ))}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleEdit}>
                    {lngsltd["Save"]}
                </Button>
                <Button variant="outlined" onClick={() => setShowEdit(false)}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

